<div class="admin-submit-modal" role="dialog" aria-labelledby="modal-title" aria-modal="true">
  <div class="admin-submit-modal__title">
    <div class="title-container">
      <mat-icon class="icon-xl" svgIcon="mail" aria-hidden="true"></mat-icon>
      <h1 id="modal-title" class="heading-s">
        Submit proposals
      </h1>
    </div>
    <app-button size="small" icon="close" type="quaternary" (click)="closeModal()"></app-button>
  </div>
  <div class="admin-submit-modal__content">
    <span class="body-l text-dark">
      You're about to submit the following fragrance proposals. Once submitted, you won’t be able to make further changes. Are you sure you want to proceed?
    </span>
  </div>
  <div class="admin-submit-modal__list">
    @for (product of adminService.selectedProducts(); track product) {
      <div class="product-item">
        <div class="product-item-content">
          <div class="product-image">
            <img [src]="product?.imageUrl" alt="fragrance" height="58" width="58" loading="lazy"/>
          </div>
          <div class="product-details">
            <span class="body-l-bold text-dark">{{ product?.name }}</span>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="admin-submit-modal__footer">
    <app-button
      type="tertiary"
      size="large"
      [text]="'Cancel'"
      (click)="closeModal()">
    </app-button>
    <app-button
      type="primary"
      size="large"
      [text]="'Submit proposals'"
      iconPosition="right"
      icon="arrow_forward"
      (click)="submitProducts()">
    </app-button>
  </div>
</div>